import { useContext } from "react";
import {SalubrisContext} from './Context';
import CenterSearchResult from "./CenterSearchResult";

const CenterListSearch = () => {

    const {centers} = useContext(SalubrisContext);
    const centersList = centers.map((center) => <CenterSearchResult key={center.friendly_url} {...center}/>);
    
    return (<div className="centers-container">
            { centersList}
    </div>);
}

export default CenterListSearch;